import dayjs from "dayjs";
import { create } from "zustand";

interface ServicesDateFilterState {
  dateRange: {
    from: Date;
    to: Date;
  };
  setDateRange: (range: { from: Date; to: Date }) => void;
}

export const useServicesDateFilterStore = create<ServicesDateFilterState>((set) => ({
  dateRange: {
    from: dayjs().subtract(1, "months").toDate(),
    to: dayjs().toDate()
  },
  setDateRange: (dateRange) => set({ dateRange })
}));
